import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { PauseCircle } from 'lucide-react';
import { buildMarketingUrl } from '@/lib/workspace';

interface WorkspaceSuspendedPageProps {
  reason: string | null;
}

export function WorkspaceSuspendedPage({ reason }: WorkspaceSuspendedPageProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="flex justify-center mb-4">
            <PauseCircle className="h-12 w-12 text-yellow-500" />
          </div>
          <CardTitle className="text-2xl">Workspace suspended</CardTitle>
          <CardDescription>
            This workspace is temporarily suspended.
            {reason ? ` Reason: ${reason}.` : ''} Please contact iCrop support to restore access.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild variant="outline">
            <a href={buildMarketingUrl()}>Back to iCrop.net</a>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
